module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/hospital02-0fd78aa570084418a69293bead49af07.svg";